//#region src/surfaces/platform-shared-modules.ts
/**
* The served modules: React 19, react-dom 19, react-router 8, and the two surface packages at
* major 1. Frozen, row by row.
*/
const PLATFORM_SHARED_MODULES = Object.freeze([
	Object.freeze({
		name: "react",
		major: 19
	}),
	Object.freeze({
		name: "react-dom",
		major: 19
	}),
	Object.freeze({
		name: "react-router",
		major: 8
	}),
	Object.freeze({
		name: "@zion/sdk-surfaces",
		major: 1
	}),
	Object.freeze({
		name: "@zion/sdk-surfaces-react",
		major: 1
	})
]);
//#endregion
export { PLATFORM_SHARED_MODULES };

//# sourceMappingURL=platform-shared-modules.js.map